import React, { useEffect, useState, useRef } from 'react';
import cn from 'classnames';

import './interestingFacts.scss';

function InterestingFacts(props) {
  const { progress } = props;


  return (
    <>
      <div
        className={cn(
          'interesting-facts first-screen__interesting-facts',
        )}>
        <div className="interesting-facts__wrap">

        <div
          className={cn(
            'interesting-facts__content',
          )}>
                  <div className="interesting-facts__bg">
          <div className="interesting-facts__bg-img">
            <img
              src="/img/interesting-facts.png"
              srcSet="/img/interesting-facts.png 1x, /img/interesting-facts@2x.png 2x"
              alt="bg"
              className="img"
            />
          </div>
        </div>
          <div className="interesting-facts__cards">
            <div className="card interesting-facts__card interesting-facts__card--1">
              <div className="card__img"></div>
              <div className="card__content">
                <h2 className="card__title">50&nbsp;млн. посетителей в&nbsp;месяц</h2>
                <p className="card__desc">Больше половины Рунета</p>
              </div>
            </div>
            <div className="card interesting-facts__card interesting-facts__card--2">
              <div className="card__img"></div>
              <div className="card__content">
                <h2 className="card__title">Первый товар, проданный на &laquo;Авито&raquo;</h2>
                <p className="card__desc">Банка кофе Nescafe</p>
              </div>
            </div>
            <div className="card interesting-facts__card interesting-facts__card--3">
              <div className="card__img"></div>
              <div className="card__content">
                <h2 className="card__title">Первый популярный тип объявлений</h2>
                <p className="card__desc">Продажа щенков и котят</p>
              </div>
            </div>
          </div>
        </div>
        <div className="interesting-facts__info">
						
							</div>
        </div>

      </div>
    </>
  );
}

export default InterestingFacts;
